import PropTypes from "prop-types";
import React, {Component} from "react";
import {AccessoryCard} from "./AccessoryCard";
import {Bike} from "../../../../../../managers/Garage/index";
import {Container, ScrollableContainer} from "../../../../../../components";
import styles from "./styles";


// class definition
export class AccessoryList extends Component {

    static propTypes = {
        parts: PropTypes.array.isRequired,
        bike: PropTypes.instanceOf(Bike).isRequired,
        onPartToggled: PropTypes.func,
        onPartInfo: PropTypes.func
    };

    static defaultProps = {
        onPartToggled: () => undefined,
        onPartInfo: () => undefined
    };

    render() {

        // resolve input
        const {parts, bike, onPartToggled, onPartInfo} = this.props;

        // create cards
        const cards = parts.map(p => (
            <AccessoryCard
                key={p.id}
                part={p}
                selected={bike.has(p)}
                onPress={() => onPartToggled(p, "accessories")}
                onInfoPress={() => onPartInfo(p)}/>
        ));

        // render view
        return (
            <ScrollableContainer style={styles.container}>
                <Container flex direction="row">
                    {cards}
                </Container>
            </ScrollableContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/components/Inventory/AccessoryList.js